<template>
  <div class="area-community-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>社区-小区绑定</span>
      </div>
      <el-row :gutter="20" class="bind-row">
        <el-col :span="6">
          <el-select v-model="bindForm.areaId" placeholder="请选择社区" clearable style="width: 100%;" @change="handleAreaChange">
            <el-option v-for="item in areaOptions" :key="item.areaId" :label="item.areaName" :value="item.areaId" />
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select v-model="bindForm.communityId" filterable placeholder="请选择小区" :loading="communityLoading"
            clearable style="width: 100%;" @change="handleCommunityChange">
            <el-option v-for="item in communityOptions" :key="item.communityId" :label="item.name"
              :value="item.communityId" :disabled="!!boundCommunityIds[item.communityId]" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleBind">绑定</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span>已绑定小区</span>
      </div>
      <el-table v-loading="loading" :data="bindList" border style="width: 100%">
        <el-table-column label="所属社区" align="center" width="180">
          <template slot-scope="scope">
            {{ getAreaName(scope.row.areaId) }}
          </template>
        </el-table-column>
        <el-table-column prop="communityName" label="小区名称" align="center" />
        <el-table-column prop="createTime" label="绑定时间" align="center" :formatter="formatDateTime" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleUnbind(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import { listAreas, saveAreaCommunity, deleteAreaCommunity, listAreaCommunities } from '@/api/community/areaApi'
import { listCommunitys } from '@/api/community/communityManageApi'
import { dateFormat, timeFormat } from '@/utils/dateUtil'

export default {
  name: 'AreaCommunityBind',
  data() {
    return {
      loading: false,
      communityLoading: false,
      areaOptions: [],
      areaMap: {},
      communityOptions: [],
      communityMap: {},
      bindList: [],
      boundCommunityIds: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      bindForm: {
        areaId: '',
        communityId: '',
        communityName: '',
        storeId: ''
      }
    }
  },
  created() {
    this.loadAreas()
    this.loadAllCommunitys()
    this.loadAllBoundCommunityIds()
    this.loadData()
  },
  methods: {
    loadAreas() {
      listAreas({ page: 1, row: 100 }).then(res => {
        const data = res.data || {}
        this.areaOptions = data.areas || []
        this.areaMap = {}
        this.areaOptions.forEach(item => {
          this.areaMap[item.areaId] = item.areaName
        })
      }).catch(() => {})
    },
    loadAllCommunitys() {
      this.communityLoading = true
      listCommunitys({
        page: 1,
        row: 1000
      }).then(res => {
        this.communityOptions = res.communitys || []
        this.communityOptions.forEach(item => {
          this.communityMap[item.communityId] = item
        })
      }).catch(() => {
        this.communityOptions = []
      }).finally(() => {
        this.communityLoading = false
      })
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.page.current,
        row: this.page.size
      }
      if (this.bindForm.areaId) {
        params.areaId = this.bindForm.areaId
      }
      listAreaCommunities(params).then(res => {
        const data = res.data || {}
        this.bindList = data.communities || []
        this.page.total = data.total || 0
      }).catch(error => {
        this.$message.error(error.message || '获取绑定列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    loadAllBoundCommunityIds() {
      listAreaCommunities({ page: 1, row: 10000 }).then(res => {
        const data = res.data || {}
        const list = data.communities || []
        this.boundCommunityIds = {}
        list.forEach(item => {
          this.boundCommunityIds[item.communityId] = true
        })
      }).catch(() => {
        this.boundCommunityIds = {}
      })
    },
    handleAreaChange() {
      this.page.current = 1
      this.loadData()
    },
    formatDateTime(row, column, cellValue) {
      if (!cellValue) {
        return '-'
      }
      return dateFormat(cellValue) + ' ' + timeFormat(cellValue)
    },
    getAreaName(areaId) {
      return this.areaMap[areaId] || '-'
    },
    handleCommunityChange(communityId) {
      const community = this.communityMap[communityId]
      if (community) {
        this.bindForm.communityName = community.name
        this.bindForm.storeId = community.storeId
      } else {
        this.bindForm.communityName = ''
        this.bindForm.storeId = ''
      }
    },
    handleBind() {
      if (!this.bindForm.areaId) {
        this.$message.warning('请选择社区')
        return
      }
      if (!this.bindForm.communityId) {
        this.$message.warning('请选择小区')
        return
      }
      saveAreaCommunity(this.bindForm).then(() => {
        this.$message.success('绑定成功')
        this.bindForm = {
          areaId: '',
          communityId: '',
          communityName: '',
          storeId: ''
        }
        this.page.current = 1
        this.loadAllBoundCommunityIds()
        this.loadData()
      }).catch(error => {
        this.$message.error(error.message || '绑定失败')
      })
    },
    handleUnbind(row) {
      this.$confirm('确认解绑该小区？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAreaCommunity({ relId: row.relId, communityId: row.communityId }).then(() => {
          this.$message.success('解绑成功')
          this.loadAllBoundCommunityIds()
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '解绑失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.area-community-container {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .bind-row {
    display: flex;
    align-items: center;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
